module.exports = __webpack_public_path__ + "img/icon-512x512.9c849406.png";